//@ts-nocheck
import { Switch } from '@mui/material';
import * as PropTypes from 'prop-types';
import './Toggle.css';

/**
 * Toggle Component
 *
 * A component that provides a toggle switch for user interaction.
 *
 * @param {Object} props - Component props
 * @param {string} props.id - Unique identifier for the toggle
 * @param {boolean} props.checked - Indicates whether the toggle is on or off
 * @param {Function} props.onChange - Callback function to handle toggle state changes
 */
const Toggle = ({ id, checked, onChange, ...props }) => {
  return (
    <Switch checked={checked || false} onChange={onChange} id={id} {...props} />
  );
};

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

Toggle.defaultProps = {
  checked: false
};

export default Toggle;
